import {
  Divider,
  Grid,
  Typography,
  Button,
  Paper,
  CircularProgress,
  Box,
} from "@mui/material";

import { format } from "date-fns";
import es from "date-fns/locale/es";

import { formatCurrency, formatDate } from "utils/misc";

const PurchaseSummary = (props) => {
  const { currentBrand, information } = props;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="title" color="primary">
          Resumen de Compra
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} container justifyContent="space-between">
        <Typography>Nombre del producto</Typography>
        <Typography variant="h5" color="primary">
          {information.product}
        </Typography>
      </Grid>
      <Grid item xs={12} container justifyContent="space-between">
        {information?.installments?.map((ins, key) => (
          <Grid item xs={12} container justifyContent="space-between" key={key}>
            <small>
              <b>{ins?.label}</b>
            </small>
            {ins?.price_discount ? (
              <Box display="flex" alignItems="center" gap="10px">
                <Typography
                  variant="h5"
                  color="primary"
                  style={{
                    textDecoration: "line-through",
                  }}
                >
                  {formatCurrency(ins?.price, currentBrand)}
                </Typography>
                <Typography variant="h5">
                  {formatCurrency(ins?.price_discount, currentBrand)}
                </Typography>
              </Box>
            ) : (
              <Box>
                <Typography variant="h5" color="primary">
                  {formatCurrency(ins?.price, currentBrand)}
                </Typography>
              </Box>
            )}
          </Grid>
        ))}
      </Grid>

      <Grid item xs={12} container justifyContent="space-between">
        <Typography>Subtotal</Typography>
        <Typography variant="h5">
          {formatCurrency(information?.subtotal, currentBrand)}
        </Typography>
      </Grid>
      <Grid item xs={12} container justifyContent="space-between">
        <Typography>Descuentos</Typography>
        <Typography variant="h5" color="primary">
          {formatCurrency(information?.discount, currentBrand)}
        </Typography>
      </Grid>
      <Grid item xs={12} container justifyContent="space-between">
        <Typography variant="h5">Total a pagar</Typography>
        <Typography variant="h5">
          {formatCurrency(information?.total, currentBrand)}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PurchaseSummary;
